<template>
  <div class="event-list-date">
    <div class="month">
      {{ month }}
    </div>
    <div class="day">
      {{ day }}
    </div>
    <div class="hour">
      <p class="start">
        {{ start }}
      </p>
      <p
        v-if="!isAllDay"
        class="end"
      >
        {{ end }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatEventTime, formatEventDay, formatEventMonth } from '../../helpers/events.helper';

defineOptions({
  name: 'EventListDate',
});

const props = defineProps({
  startDate: {
    type: String,
    default: null,
  },
  endDate: {
    type: String,
    default: null,
  },
  isAllDay: Boolean,
  isMulti: Boolean,
});

const { $t, $intl } = useNuxtApp();

const intlLocale = computed(() => $intl.locale);

const date = computed(() => (props.isMulti ? props.endDate : props.startDate));

const month = computed(() => $t(`events.labelMonths.${formatEventMonth(date.value)}`));

const day = computed(() => formatEventDay(date.value, intlLocale.value));

const start = computed(() => {
  if (props.isAllDay) {
    return 'All Day';
  }
  return props.startDate && formatEventTime(props.startDate, intlLocale.value);
});

const end = computed(() => props.endDate && formatEventTime(props.endDate, intlLocale.value));
</script>

<style lang="scss" scoped>
@use '../../../../global/scss/mixins/flex_mixin';

.event-list-date {
  @include flex_mixin.flex-column;
  text-transform: uppercase;

  .month {
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    line-height: 20px;
    text-align: center;
  }

  .day {
    font-style: normal;
    font-weight: bold;
    font-size: 2em;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.01em;
    margin-bottom: 8px;
  }

  .hour {
    font-style: normal;
    font-weight: normal;
    font-size: 0.7em;
    line-height: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
